export var localBreadcrumbs = function localBreadcrumbs(strictLocalize) {
  return {
    HOME: strictLocalize({
      id: "zXMIoX",
      defaultMessage: [{
        "type": 0,
        "value": "Início"
      }]
    }),
    POPULAR_GUIDES: strictLocalize({
      id: "AuCq+K",
      defaultMessage: [{
        "type": 0,
        "value": "Guias populares"
      }]
    }),
    SEARCH: strictLocalize({
      id: "heC0E1",
      defaultMessage: [{
        "type": 0,
        "value": "Pesquisar"
      }]
    }),
    RETAILER_GUIDES: strictLocalize({
      id: "0uLEFs",
      defaultMessage: [{
        "type": 0,
        "value": "Guias do revendedor"
      }]
    }),
    BRAND_GUIDES: strictLocalize({
      id: "VAqQy9",
      defaultMessage: [{
        "type": 0,
        "value": "Guias de marca"
      }]
    })
  };
};